import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { TertiaryButton } from '@components/library/button';
import { PressReleaseUpsert } from './PressReleaseTypes';

import classes from './styles/press_release_form_step4.module.scss';

interface PressReleaseFormStep4Props {
  handleClose: SetStateDispatch<boolean>;
  pressRelease: PressReleaseUpsert;
}

/**
 * Step 4: Success/Confirmation
 * @param {PressReleaseFormStep4Props} PressReleaseFormStep4Props
 */
export const PressReleaseFormStep4: FunctionComponent<PressReleaseFormStep4Props> = ({ handleClose, pressRelease }) => (
  <div className={classes.success} id="success">
    <span className={classnames("bff-check-mark", classes.icon)} role="img" />
    <h3 className={classes.h3}>{bfTranslate('Success!')}</h3>
    <p className={classes.p}>
      {bfTranslate('Your email has been sent:')}{' '}{pressRelease?.subject ? <><strong>{pressRelease?.subject}</strong></> : null}
    </p>
    <TertiaryButton
      id="success-close"
      onClick={(): void => {
        handleClose(false);
      }}
    >
      {bfTranslate('Close')}
    </TertiaryButton>
  </div>
);
